import { fetchWithAuth } from "../FetchHelper";

const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuarisIdAulaIdBbddNotes = async (id_user: string, id_aula: string) => {
    try {
        const response = await fetchWithAuth(`${apiUrl}:8061/bbdd/usuaris/${id_user}/aula/${id_aula}/notes`);
        if (response && response.ok) {
            return await response.json();
        }
        return null;
    } catch (error) {
        console.log('Error al obtener las notas de aula BBDD:', error);
        return null;
    }
};

